import './BillingInfoForm.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const BillingInfoForm = () => {
    return ( 
        <div className="billinginfoform">
            <h3>Billing Information</h3>
                        
            <form className="container-fluid" action="submit">
                <div className="row">
                    <div className="d-flex flex-column col-md-6 col-sm-12 col-lg-6">
                        <label htmlFor="">FIRST NAME</label>
                        <input type="text" name="" id="" placeholder="First Name" />
                    </div>
                    <div className="d-flex flex-column col-md-6 col-sm-12 col-lg-6">
                    <label htmlFor="">LAST NAME</label>
                        <input type="text" name="" id="" placeholder="First Name" />
                    </div>
                </div>

                <div className="row">
                    <div className="d-flex flex-column col-md-6 col-sm-12 col-lg-6">
                    <label htmlFor="">YOUR EMAIL</label>
                        <input type="email" name="" id="" placeholder="Your Email" />
                    </div>
                    <div className="d-flex flex-column col-md-6 col-sm-12 col-lg-6">
                    <label htmlFor="">YOUR PHONE</label>
                        <input type="tel" name="" id="" placeholder="Your Phone" />
                    </div>
                </div>

                <div className="row">
                    <div className="d-flex flex-column col-md-6 col-sm-12 col-lg-4">
                        <label for="country">COUNTRY</label>
                        <select id="" name="country" placeholder="Country">
                            <option value="">Country</option>
                            <option value="">Siberia</option>
                            <option value="">Ghana</option>
                            <option value="">Australia</option>
                        </select>
                    </div>
                    <div className="d-flex flex-column col-md-6 col-sm-12 col-lg-4">
                        <label for="city">CITY</label>
                        <select id="" name="City" placeholder="City">
                            <option value="">City</option>
                            <option value="">Siberia</option>
                            <option value="">Ghana</option>
                            <option value="">Australia</option>
                        </select>
                    </div>
                    <div className="d-flex flex-column col-md-12 col-sm-12 col-lg-4">
                        <label for="zip code">ZIP CODE</label>
                        <select id="" name="" placeholder="Zip Code">
                            <option value="">Zip Code</option>
                            <option value="">Siberia</option>
                            <option value="">Ghana</option>
                            <option value="">Australia</option>
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className="d-flex flex-column col-md-6 col-sm-12 col-lg-4">
                        <label for="state">STATE</label>
                        <select id=""  name="" placeholder="State">
                            <option value="">State</option>
                            <option value="">Siberia</option>
                            <option value="">Ghana</option>
                            <option value="">Australia</option>
                        </select>
                    </div>

                    <div className="d-flex flex-column col-md-6 col-sm-12 col-lg-8">
                    <label htmlFor="">ADDRESS</label>
                        <input type="text" name="" id="" placeholder="Address" />
                    </div>
                </div>
            </form>
        </div>
     );
}
 
export default BillingInfoForm;